import React, { Component } from 'react';
import { getApiHeader, removeUserSession } from '../../../utils/CommonFunctions';
import axios from 'axios';
import swal from 'sweetalert';
import PageLoader from '../../Loader/loader';
import PlanTabs from './PlanList/PlanTab';
import Plan from './PlanList/Plan';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;


class PostPaidChangePlan extends Component {

    state = {
        loading: false,
        plans: [],
        nbn_api_log_id: '',
        plan_details: [],
        model_visibility: false,
        // select_plan_id: '',
        response_message:'',
        selected_number: "",
        customer_activations:[],
        reference_number: '',
        reference_number_applied:false,
        reference_number_plan:null,
        is_sim_credit_plan:false,
        seletedPlanId:null,
        reference_number: '',
        reference_number_applied: false,
        reference_number_plan: null,
        is_sim_credit_plan:false,
        changePlansId:"",
        NumberchangHandler:false,
    }

    componentDidMount() {
         this.getActivations();

       
    }

      getActivations = async () => {
        let headers = await getApiHeader();
        let res = await axios.get(`${SERVER_URL}postpaid/user_activations`, { headers }).then(async response => {

            let data = response.data.data.list;
            let selected_number = '';
            let mobile = '';
            const { location } = this.props;


            if (data.length > 0) {
                    selected_number = data[0].activation_id;
                    mobile = data[0].mobile_number
             
            } else {

                selected_number = null;
                mobile = null;
            }

            let mobileNumber = sessionStorage.getItem("postpaidselectedNum");

            console.log("mobileNumber-----> in change plan", mobileNumber);



            if (mobileNumber) {
              const index = data.findIndex(item => item.mobile_number === mobileNumber);
            
              if (index !== -1) {
                // Take out the matched item
                const [matched] = data.splice(index, 1);
                // Put it at the front
                data.unshift(matched);
              }
            
              this.setState({ customer_activations: data });
            } else {
              this.setState({ customer_activations: data });
            }

            //  this.setState({ customer_activations: data });
             this.setState({ loading: false });

        }).catch(error => {
        
         swal("Internal Server Error", "", "warning");
           
        });

    };

    handleClose = () => this.setState({ model_visibility: false });


    getDefaultPlans = async (selected_number) => {

        this.setState({ loading: true });
        let headers = await getApiHeader();
        const post_data = {
            post_paid_activation_id: selected_number
        };
        let res = await axios.post(`${SERVER_URL}postpaid/pst-pln-cge`, post_data, { headers }).then(response => {
          
            let data = response.data.data;
            this.setState({ plans: data.plans })
            this.setState({ loading: false, plans: data.plans, nbn_api_log_id: data.nbn_api_log_id });

        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }

    PlanSelectHandler = async (plan_id) => {
        this.setState({ loading: true });
        let headers = await getApiHeader();
        const post_paid_activation_id= this.state.NumberchangHandler===true?this.state.selected_number : sessionStorage.getItem("postpaid_activation_id")
     
        const post_data = {
            post_paid_plan_id: plan_id,
            post_paid_activation_id: post_paid_activation_id
        };
        let res = await axios.post(`${SERVER_URL}postpaid/pst-pln-cge_dtls`, post_data, { headers }).then(response => {
            if (response.data.data.customMessage) {
                if (response.data.data.customMessage !== 'undefined') {
                    this.setState({ customMesssge: response.data.data.customMessage });
                }
            }
            let data = response.data.data;
            this.setState({response_message :response.data.message})
            this.setState({ plan_details: data })
            this.setState({ loading: false, select_plan_id: plan_id });
            swal({
                text: response.data.message,
                icon: "warning",
                closeOnClickOutside: false,
                content:this.state.plan_details?.is_upgrade == "1"? {  
                    element: "div", attributes: {
                                        innerHTML: `
                                        
                    <div style="margin-top:15px ,width:300px;">
                    <label
                        style="
                        display:flex;
                        flex-direction:column;
                        align-items:flex-start;
                        gap:12px;
                        color:#000000a3;
                        font-size:12px;
                        cursor:pointer;
                        font-weight:600
                        "
                    >
                        <div style="display:flex; gap:8px;">
                        <input
                            type="checkbox"
                            id="immediatePlanChange"
                            onclick="document.getElementById('nextCyclePlanChange').checked = false;"
                            style="
                            width:14px;
                            height:14px;
                            accent-color:#C11D6C;
                            margin:0;
                            flex-shrink:0;
                            "
                        />
                        <span style="line-height:1.4;">
                            I want to change the plan effective immediately and pay $${this.state.plan_details.payable_amount} now .
                        </span>
                        </div>

                        <div style="display:flex; gap:8px;">
                        <input
                            type="checkbox"
                            id="nextCyclePlanChange"
                            onclick="document.getElementById('immediatePlanChange').checked = false;"
                            style="
                            width:14px;
                            height:14px;
                            accent-color:#C11D6C;
                            margin:0;
                            flex-shrink:0;
                            "
                        />
                        <span style="line-height:1.4;">
                            I want the new plan to be applied from next billing cycle on ${this.state.plan_details?.billing_date} .
                        </span>
                        </div>
                    </label>
                    </div>
                `,
                    }
                        }
                  : undefined,
              buttons: {
                cancel: "Cancel",
                confirm: {
                  text: "Submit",
                  value: true,
                },
              },
            }).then((confirmed) => {
              if (!confirmed) {
                return;
              }

              let isImmediatePlanChange = false;

              if (this.state.plan_details?.is_upgrade == "1") {
                isImmediatePlanChange =
                  document.getElementById("immediatePlanChange")?.checked ||
                  false;
              }

              if (isImmediatePlanChange) {
                this.ImmediateChangePlanSubmitHandler(plan_id);
              } else {
                this.ChangePlanSubmitHandler(plan_id);
              }
            });
         
        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }


    ChangePlanSubmitHandler = async (plan_id) => {
        this.setState({ loading: true, model_visibility: false });
        let headers = await getApiHeader();
        const post_paid_activation_id= this.state.NumberchangHandler===true?this.state.selected_number : sessionStorage.getItem("postpaid_activation_id") 
         const post_data = {
            post_paid_plan_id: plan_id,
            post_paid_activation_id: post_paid_activation_id
        };
        let res = await axios.post(`${SERVER_URL}postpaid/cfrm-pst-pln_cge`, post_data, { headers }).then(response => {
            if (response.data.data.customMessage) {
                if (response.data.data.customMessage !== 'undefined') {
                    this.setState({ customMesssge: response.data.data.customMessage });
                }
            }
            this.setState({ loading: false });
            if (response.status === 200) {

                swal('Success', response.data.data);
            }
        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }

    ImmediateChangePlanSubmitHandler = async (plan_id) => {
        this.setState({ loading: true, model_visibility: false });
        let headers = await getApiHeader();
        const post_paid_activation_id= this.state.NumberchangHandler===true?this.state.selected_number : sessionStorage.getItem("postpaid_activation_id") 
         const post_data = {
            post_paid_plan_id: plan_id,
            post_paid_activation_id: post_paid_activation_id
        };
        let res = await axios.post(`${SERVER_URL}postpaid/cfrm-pst-imdt-pln_cge`, post_data, { headers }).then(response => {
            if (response.data.data.customMessage) {
                if (response.data.data.customMessage !== 'undefined') {
                    this.setState({ customMesssge: response.data.data.customMessage });
                }
            }
            this.setState({ loading: false });
            if (response.status === 200) {

                swal('Success', response.data.data);
            }
        }).catch(error => {
            this.setState({ loading: false });
            if ((typeof (error.response.data.message) !== 'undefined') && (typeof (error.response.data) !== 'undefined')) {

                swal({
                    text: error.response.data.message,
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    icon: "warning"
                }).then(() => {

                });
            }
            else {
                swal("Internal Server Error", "", "warning");
            }
        });
    }

    setSelectedPlan = async (plan_id, reference_number_applied, plan, reference_number, is_sim_credit_plan)=>{
        this.setState({seletedPlanId: plan_id, reference_number_applied:reference_number_applied, reference_number_plan:plan, reference_number:reference_number, is_sim_credit_plan:is_sim_credit_plan},()=>{

            if(reference_number_applied === true)
            {
                this.setState({reference_number_plan:plan});
            }

        });

    }

    goNextStep = (plan)=>{

        let plan_id = plan.plan_id;
        let plan_added = true;
        if(this.state.seletedPlanId == null)
        {
            plan_added = false;
        }
        
       
        this.PlanSelectHandler(plan);
        // return;
        
    }

    handleNumberChange = (event) => {
        this.setState({NumberchangHandler:true})
        const selectedNumber = event.target.value;
        this.setState({ selected_number: selectedNumber });
        this.setState({changePlansId:selectedNumber})  
    };

    render() {

        return (
            <>
                {this.state.loading === true ? <PageLoader /> : null}
                <div className="container" id="nbn-planSelectionBox">
                    <section className="nbn-common-section">
                    <div className="row">
                            <div className="col-lg-10 col-xl-10 order-lg-1 order-xl-1">
                            </div>
                            <div className="col-lg-2 col-xl-2 order-lg-2 order-xl-2">
                                <div className="form-group row"  style={{ display: "flex", marginLeft: "auto", justifyContent: "flex-end" ,marginTop:"10px"}}>
                                    <div className="col-lg-10 col-md-12 col-sm-12 number-select custom-select num-picker">
                                        <select
                                            className="form-select"
                                            name="activation"        
                                            onChange={this.handleNumberChange}    
                                            value={this.state.selected_number || ''}       
                                        >
                                            {this.state.customer_activations.filter((activation) => activation.is_wme_prepaid === 0).map(person => (
                                                <option
                                                    key={person.activation_id}
                                                    className="m--bg-success kt-font-inverse-success"
                                                    value={person.activation_id}
                                                    mobileNumber={person.mobile_number}              
                                                >
                                                    {person.mobile_number}
                                                </option>
                                            ))}
                                        </select>

                                    </div>
                                </div>
                            </div>
                        </div> 


                      



                        <div className="row">
                            
                            <div className="nbn-header-title">
                                <h2 className="nbn-h3"> Choose Your Telsim  SIM Only Plans</h2>
                                <p style={{ textAlign: "left" }}>Discover the best SIM Only plans from Telsim that can be designed to your needs at different speeds.</p>
                            </div>


                            <PlanTabs setSelectedPlan={this.setSelectedPlan} activeSection="28-day_plan" from="change-plan" goNextStep={this.goNextStep}  changePlanNum={this.state.changePlansId} />
                            {/* : <Plan plan_reference_number={this.state.reference_number} referenceNumberApplied={true} plan={this.state.reference_number_plan} selectedPlan={this.state.reference_number_plan} /> */}




                        </div>
                    </section>
                    <br />
                </div>
            </>
        );
    }

}

export default PostPaidChangePlan;

